<template>
  <div class="pb-5">
    <nav-bar/>
    <sidebar-toggle-button/>
    <chat-page/>
    <ticket-button/>

    <!-- Sidebar -->
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow" v-if="$store.state.isSidebarOpen">
      <ul class="nav flex-column">
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="openModification()">{{$t('OrderInfo.sidebar.modification')}}</a>
        </li>
        <li v-if="!$route.query.archivedOrder" class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="openDispatch()">{{$t('OrderInfo.sidebar.dispatch')}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="openInspection()">{{$t('OrderInfo.sidebar.inspection')}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" :href="originalOrder.invoice" target="_blank">{{$t('OrderInfo.sidebar.purchase')}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" :href="originalOrder.docs" target="_blank">{{$t('Document')}}</a>
        </li>
        <li v-if="!$route.query.archivedOrder" class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="checkHistory(getOrderId, originalOrder.historySync); openSend()">{{$t('OrderInfo.sidebar.send')}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="openSendDocs()">{{$t('OrderInfo.sidebar.send_docs')}} <i class="ml-1 fa fa-regular fa-envelope"></i></a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="chat = true">{{$t('OrderInfo.sidebar.chat')}}</a>
          <span v-if="notes.length > 0" class="pull-right badge badge-default">{{ notes.length }}</span>
        </li> -->
        <li v-if="!$route.query.archivedOrder" class="nav-item">
          <span class="navbar-text pull-left pl-3">{{$t('OrderInfo.sidebar.statusChange')}}</span>
          <select class="form-control" :value="originalOrder.status" @change="checkHistory(getOrderId, originalOrder.historySync); changeStatus($event.target.value);">
            <option value="Dispatch">{{$t('Search.status.dispatch')}}</option>
            <option value="Processing">{{$t('Search.status.processing')}}</option>
            <option value="Pick">{{$t('Search.status.pick')}}</option>
            <option value="Attente">{{$t('Search.status.waiting')}}</option>
            <option value="Transit">{{$t('Search.status.transit')}}</option>
            <option value="Drop">{{$t('Search.status.drop')}}</option>
            <!-- <option v-if="$store.state.userInfo && !$store.state.userInfo.isSageOne" value="Terminée">{{$t('Search.status.finished')}}</option>-->
            <option value="Transférée">{{$t('Search.status.transfered')}}</option>
            <option value="Reject">{{$t('Search.status.rejected')}}</option>
            <option value="Inspection">{{$t('Search.status.inspection')}}</option>
            <option value="Cancel">{{$t('Search.status.canceled')}}*</option>
            <option value="Terminée">{{$t('Search.status.finished')}}*</option>
           </select>
        </li>
        <button id="chat" class="btn btn-kne-orange col-12 mt-3 text-left" @click="openNote(notes, true)">
          {{$t('OrderInfo.sidebar.chat')}}
          <span v-if="notes.length > 0" class="pull-right badge btn-badge badge-default">{{ notes.length }}</span>
        </button>

        <button v-if="isOrderTransfered && !isTransferArchived" id="chat" class="btn btn-kne-orange col-12 mt-3 text-left" @click="openNote(transferNotes, false)">
          {{$t('OrderInfo.sidebar.transfer_chat')}}
          <span class="pull-right badge btn-badge badge-default">{{ transferNotes.length }}</span>
        </button>
        <button v-if="isOrderTransfered && isTransferArchived" id="chat" class="btn btn-kne-orange col-12 mt-3 text-left" @click="openNote(transfer2Notes, false)">
          {{$t('OrderInfo.sidebar.transfer_chat')}}
          <span class="pull-right badge btn-badge badge-default">{{ transfer2Notes.length }}</span>
        </button>

        <button v-if="returnIsOrderArchived" class="btn btn-kne-green mt-3" id="reprocess" @click="onReprocessOrder()">{{$t('ReprocessOrder.button_reprocess')}}</button>
      </ul>
    </div>

    <!-- ORDER INFO -->
    <div class="main-content-container my-5" :class="{'f-column' : isScreenSmall}">

      <div class="text-info-container border card font-grey mx-2 mb-2">
        <h3 class="kne-title">{{$t('OrderInfo.order_info_title')}} - {{getOrderId}}</h3>
        <div class="px-2 flex f_column">
          <div class="flex f_row" id="other">
            <!-- DOCS -->
            <div class="other-info border mx-2">
              <h5 class="kne-subtitle">{{$t('OrderInfo.documents.title')}}</h5>
              <div v-if="originalOrder.docs">
                <p class="ml-2">
                  <strong>{{$t('OrderInfo.documents.release')}}:</strong> <a :href="originalOrder.docs" target="_blank">{{$t('Document')}}</a>
                </p>
              </div>
              <p v-else class="text-center m-1">{{$t('OrderInfo.documents.no_docs')}}</p>
            </div>
            
            <!-- SIGNATURE -->
            <div class="other-info border mx-2">
              <h5 class="kne-subtitle">{{$t('OrderInfo.signature.title')}}</h5>
              <div v-if="originalOrder.signataire">
                <p class="ml-2">
                  <strong>{{originalOrder.signataire}}</strong> {{$t(originalOrder.dateSignataire)}}
                </p>
              </div>
              <div v-else class="text-center m-1">{{$t('OrderInfo.signature.no_signature')}}</div>
            </div>
          </div>

          <span class="info my-3">
            <strong>{{$t('OrderInfo.information.status')}}</strong>
            <span v-if="originalOrder.status === 'Dispatch'" class="float-right">{{$t('Search.status.dispatch')}}</span>
            <span v-if="originalOrder.status === 'Processing'" class="float-right">{{$t('Search.status.processing')}}</span>
            <span v-if="originalOrder.status === 'Pick'" class="float-right">{{$t('Search.status.pick')}}</span>
            <span v-if="originalOrder.status === 'Attente'" class="float-right">{{$t('Search.status.waiting')}}</span>
            <span v-if="originalOrder.status === 'Transit'" class="float-right">{{$t('Search.status.transit')}}</span>
            <span v-if="originalOrder.status === 'Drop'" class="float-right">{{$t('Search.status.drop')}}</span>
            <span v-if="originalOrder.status === 'Cancel'" class="float-right">{{$t('Search.status.canceled')}}</span>
            <span v-if="originalOrder.status === 'Terminée'" class="float-right">{{$t('Search.status.finished')}}</span>
            <span v-if="originalOrder.status === 'Transférée'" class="float-right">{{$t('Search.status.transfered')}}</span>
            <span v-if="originalOrder.status === 'Reject'" class="float-right">{{$t('Search.status.rejected')}}</span>
            <span v-if="originalOrder.status === 'Inspection'" class="float-right">{{$t('Search.status.inspection')}}</span>
          </span>
          <!-- <span class="info my-3"><strong>{{$t('DOCUMENTS')}}</strong>
            <a :href="originalOrder.docs" class="float-right" target="_blank">{{ originalOrder.docs || '-'}}</a>
          </span> -->
          <span class="info my-3"><strong>{{$t('OrderInfo.information.creationDate')}}</strong> <span class="float-right">{{ getDate(originalOrder.creationDate) || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.VIN')}}</strong>          <span class="float-right">{{ originalOrder.vin || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.year')}}</strong>         <span class="float-right">{{ originalOrder.year  || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.make')}}</strong>         <span class="float-right">{{ originalOrder.make  || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.model')}}</strong>        <span class="float-right">{{ originalOrder.model || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.pickup')}}</strong>       <span class="float-right">{{ originalOrder.transmitterName || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.delivery')}}</strong>     <span class="float-right">{{ originalOrder.receiverName  || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.billing')}}</strong>      <span class="float-right">{{ originalOrder.payerName || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.price')}}</strong>
            <span v-if="originalOrder.price" class="float-right">{{ ((parseFloat(originalOrder.price)).toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' })) }}</span>
            <span v-else>-</span>
          </span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.reference')}}</strong>    <span class="float-right">{{ originalOrder.numRef || '-'}}</span></span>
          <span v-if="originalOrder.manuallyBilled" class="info my-3"><strong>{{$t('OrderInfo.information.facture')}}</strong>  <span class="float-right">{{ originalOrder.billNum }}</span></span>
          <span v-if="companyUID === 'e58ff614-8449-4c3e-90b8-b42a48c2972b' && originalOrder.status === 'Terminée' && !originalOrder.manuallyBilled"
          class="info my-3"><strong>{{$t('OrderInfo.information.facture')}}</strong> <span class="float-right">S1- {{ originalOrder['.key'] || '-'}} </span></span>
          <span v-if="companyUID !== 'e58ff614-8449-4c3e-90b8-b42a48c2972b' || originalOrder.status !== 'Terminée'" class="info my-3"><strong>{{$t('OrderInfo.information.facture')}}</strong><span class="float-right">{{ originalOrder.billNum || '-'}} </span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.comment')}}</strong><span class="float-right">{{ originalOrder.comment || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.keys')}}</strong><span class="float-right">{{ originalOrder.nbKey || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.trackingCode')}}</strong><span class="float-right">{{ originalOrder.codeSecret || '-'}}</span></span>
          <span class="info my-3"><strong>{{$t('OrderInfo.information.cancelReason')}}</strong><span class="float-right">{{ originalOrder.cancelReason || '-'}}</span></span>
        </div>
      </div>

      <div class="special-info-container mx-2">
        <div class="border" id="location">
          <v-map :zoom="12" :center="[order.latitude, order.longitude]">
            <v-tilelayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"/>
            <v-marker :lat-lng="[order.latitude, order.longitude]"></v-marker>
          </v-map>
        </div>

        <div>
          <!-- History -->
          <transfer-history
            v-if="originalOrder.historySync"
            :title="$t('OrderInfo.delivery.title')"
            :history="originalOrder.historySync"
            :order="originalOrder"
            :orderId="getOrderId"
            :priceOrderLink="setPriceOrderLink(getOrderId, originalOrder)"
            :isShowDescription="false"
            :isOrderArchived="returnIsOrderArchived"
          />
        </div>

        <!-- Photos -->
        <div class="my-2" id="photo">
          <div class="card border pb-2 mb-2">
            <h5 class="kne-title">{{$t('OrderInfo.carPhotos.photos')}}</h5>
            <div class="photo-container">
              <img v-for="photoUrl in originalOrder.photos" :key="photoUrl" :src="photoUrl" class="img-fluid mini" @click="openPreview($event.target.currentSrc)">
            </div>
            <p v-if="!order.photos" class="text-center">{{$t('OrderInfo.carPhotos.no_vehicle_photos')}}</p>
          </div>

          <div class="card border pb-2 mb-2">
            <h5 class="kne-title">{{$t('OrderInfo.carPhotos.bodyPhotos')}}</h5>
            <div class="photo-container">
              <img v-for="photoUrl in originalOrder.bodyPhotos" :key="photoUrl" :src="photoUrl" class="img-fluid mini" @click="openPreview($event.target.currentSrc)">
            </div>
            <p v-if="!order.bodyPhotos" class="text-center">{{$t('OrderInfo.carPhotos.no_body_photos')}}</p>
          </div>

          <div v-if="originalOrder.historySync">
            <div class="card border pb-2 mb-2">
              <h5 class="kne-title">{{$t('OrderInfo.carPhotos.signaturePhotos')}}</h5>
              <div v-if="checkHasFieldInObject(originalOrder.historySync, 'pickSignature')" class="mb-3 photo-container">
                <img v-for="(entry, index) in originalOrder.historySync" :key="index" :src="entry.pickSignature" class="img-fluid mini" @click="openPreview($event.target.currentSrc, entry.pickName, entry.nightPickComment, entry['.key'])">
              </div>
              <p v-else class="text-center">{{$t('OrderInfo.carPhotos.no_pick_signature')}}</p>
            </div>

            <div class="card border pb-2 mb-2">
              <h5 class="kne-title">{{$t('OrderInfo.carPhotos.signatureDrop')}}</h5>
              <div v-if="checkHasFieldInObject(originalOrder.historySync, 'dropSignature')" class="mb-3 photo-container">
                <img v-for="(entry, index) in originalOrder.historySync" :key="index" :src="entry.dropSignature" class="img-fluid mini" @click="openPreview($event.target.currentSrc, entry.dropName, entry.nightDropComment, entry['.key'])">
              </div>
              <p v-else class="text-center">{{$t('OrderInfo.carPhotos.no_drop_signature')}}</p>
            </div>

            <div class="card border pb-2 mb-2">
              <h5 class="kne-title">{{$t('OrderInfo.carPhotos.dropPhotos')}}</h5>
              <div v-if="checkHasFieldInObject(originalOrder.historySync, 'dropPhotos')" class="mb-3 photo-container">
                <div v-for="(dispatch, index) in originalOrder.historySync" :key="index">
                  <img v-for="entry in dispatch.dropPhotos" :key="entry" :src="entry" class="img-fluid mini" @click="openPreview($event.target.currentSrc)">
                  <p class="text-center">
                    {{dispatch.nightDropComment}}
                  </p>
                </div>
              </div>
              <p v-else class="text-center">{{$t('OrderInfo.carPhotos.no_drop_photos')}}</p>
            </div>
          </div>
        </div>

        <div v-if="isOrderTransfered">
          <div v-if="!isTransferArchived" class="mt-4">
            <button v-if="transfer.historySync" class="btn btn-kne-orange" @click="forceUpdate()">{{$t('OrderInfo.transfered.btn_drop_history_from_transfer')}}</button>
            <div v-else class="card border pb-2 mb-2">
              <h5 class="kne-title">{{$t('OrderInfo.transfered.title_drop_history_from_transfer')}}</h5>
              <p class="text-center">{{$t('OrderInfo.transfered.no_drop_history_from_transfer')}}</p>
            </div>
          </div>

          <div v-else class="mt-4">
            <button v-if="transfer2.historySync" class="btn btn-kne-orange" @click="forceUpdate()">{{$t('OrderInfo.transfered.btn_drop_history_from_transfer')}}</button>
            <div v-else class="card border pb-2 mb-2">
              <h5 class="kne-title">{{$t('OrderInfo.transfered.title_drop_history_from_transfer')}}</h5>
              <p class="text-center">{{$t('OrderInfo.transfered.no_drop_history_from_transfer')}}</p>
            </div>
          </div>

          <!-- TRANSFER -->
          <transfer-history
            v-if="transfer.historySync"
            :title="$t('OrderInfo.transfered.title_drop_history_from_transfer')"
            :isShowHistory="showHistory"
            :history="transfer.historySync"
            :order="transfer"
            :orderId="transfer['.key']"
            :priceOrderLink="setPriceOrderLink(transfer['.key'], originalOrder)"
            :isShowDescription="false"
          />
          <!-- TRANSFER2 -->
          <transfer-history
            v-if="isTransferArchived && transfer2.historySync"
            ref="historyPage"
            :title="$t('OrderInfo.transfered.title_drop_history_from_transfer')"
            :isShowHistory="showHistory"
            :history="transfer2.historySync"
            :order="transfer2"
            :orderId="transfer2['.key']"
            :priceOrderLink="setPriceOrderLink(transfer2['.key'], originalOrder)"
            :isShowDescription="false"
          />

          <!-- TRANSFER -->
          <table-element
            :title="$t('OrderInfo.transfered.title')"
            :fields="fieldsTRF"
            :arrOfElement="[transfer]"
            :sortSpacing="0"
            :isShowFilter="false"
            :sortable="false"
            class="card mt-4"
          >
            <template #header-actions>
            </template>

            <template #pre-body-content>
            </template>

            <template #body-content-desktop="content">
              <!-- List of orders Transfer -->
              <tr v-for="(transfer, index) in content.results"
              v-if="transfer.transpName"
              class="table-element_hover text-center"
              :id="'transfer' + index"
              :key="'transfer' + index">
                <td>{{transfer.transpName || '-'}}</td>
                <td>{{transfer.orderRef || '-'}}</td>
                <td>{{transfer['.key'] || '-'}}</td>
                <td>{{transfer.vin || '-'}}</td>
                <td>{{getDate(transfer.creationDate || '-')}}</td>
                <td>{{transfer.transmitterName || '-'}}</td>
                <td>{{transfer.receiverName || '-'}}</td>
                <td>
                  {{transfer.status}}
                  <hover-tool-tip
                    left top
                    :clickable="false"
                    :iconColor="''"
                    :text="getNotesText(transfer)"
                  />
                </td>
                <td>{{originalOrder.refTransfered || '-'}}</td>
                <td>{{originalOrder.priceTransfered || '-'}} $</td>
              </tr>

              <!-- List of orders Transfer2 -->
              <tr v-for="(transfer, index) in content.results"
              v-if="isTransferArchived && transfer2.transpName"
              class="table-element_hover text-center"
              :id="'transfer' + index"
              :key="'transfer' + index">
                <td>{{transfer2.transpName || '-'}}</td>
                <td>{{transfer2.orderRef || '-'}}</td>
                <td>{{transfer2['.key'] || '-'}}</td>
                <td>{{transfer2.vin || '-'}}</td>
                <td>{{getDate(transfer2.creationDate || '-')}}</td>
                <td>{{transfer2.transmitterName || '-'}}</td>
                <td>{{transfer2.receiverName || '-'}}</td>
                <td>
                  {{transfer2.status}}
                  <hover-tool-tip
                    left
                    top
                    :clickable="false"
                    :iconColor="''"
                    :text="getNotesText(transfer2)"
                  />
                </td>
                <td>{{originalOrder.refTransfered || '-'}}</td>
                <td>{{originalOrder.priceTransfered || '-'}} $</td>
              </tr>
            </template>

            <template #body-content-mobile="content">
              <!-- List of orders Mobile Transfer -->
              <div v-for="(order, index) in content.results"
              v-if="transfer.transpName"
              class="my-3 mx-2"
              :key="index">
                <div class="card">
                  <div class="card-header m-2">
                    <h3>{{transfer['.key']}}</h3>
                    <p><i class="fa fa-calendar mx-1"></i>{{getDate(transfer.creationDate) || '-'}}</p>
                    <p><i class="fa fa-exclamation mx-1"></i> {{transfer.status || '-'}}</p>
                  </div>
                  <div class="m-2">
                    <p v-if="transfer.orderRef"><i class="fa fa-asterisk mx-1"></i>{{transfer.orderRef}}</p>
                    <p v-else><i class="fa fa-asterisk mx-1"></i>-</p>
                    <p><i class="fa fa-building mx-1"></i>{{transfer.transpName || '-'}}</p>
                    <p><i class="fa fa-car mx-1"></i>{{transfer.vin || '-'}}</p>
                    <p><i class="fa fa-home mx-1"></i>{{transfer.transmitterName || '-'}}</p>
                    <p><i class="fa fa-truck mx-1"></i>{{transfer.receiverName || '-'}}</p>
                    <p v-if="originalOrder.refTransfered"><i class="fa fa-dollar mx-1"></i>{{originalOrder.refTransfered}}$</p> <p v-else>-</p>
                    <p v-if="originalOrder.priceTransfered"><i class="fa fa-dollar mx-1"></i>{{originalOrder.priceTransfered}}$</p> <p v-else>-</p>
                  </div>
                </div>
              </div>

              <!-- List of orders Mobile Transfer2 -->
              <div v-for="(order, index) in content.results"
              v-if="isTransferArchived && transfer2.transpName"
              class="my-3 mx-2"
              :key="index">
                <div class="card">
                  <div class="card-header m-2">
                    <h3>{{transfer2['.key']}}</h3>
                    <p><i class="fa fa-calendar mx-1"></i>{{getDate(transfer2.creationDate) || '-'}}</p>
                    <p><i class="fa fa-exclamation mx-1"></i> {{transfer2.status || '-'}}</p>
                  </div>
                  <div class="m-2">
                    <p v-if="transfer.orderRef"><i class="fa fa-asterisk mx-1"></i>{{transfer2.orderRef || '-'}}</p>
                    <p v-else><i class="fa fa-asterisk mx-1"></i>-</p>
                    <p><i class="fa fa-building mx-1"></i>{{transfer2.transpName || '-'}}</p>
                    <p><i class="fa fa-car mx-1"></i>{{transfer2.vin || '-'}}</p>
                    <p><i class="fa fa-home mx-1"></i>{{transfer2.transmitterName || '-'}}</p>
                    <p><i class="fa fa-truck mx-1"></i>{{transfer2.receiverName || '-'}}</p>
                    <p v-if="originalOrder.refTransfered"><i class="fa fa-dollar mx-1"></i>{{originalOrder.refTransfered}}$</p> <p v-else>-</p>
                    <p v-if="originalOrder.priceTransfered"><i class="fa fa-dollar mx-1"></i>{{originalOrder.priceTransfered}}$</p> <p v-else>-</p>
                  </div>
                </div>
              </div>
            </template>

            <template #post-body-content>
              <div class="row m-3">
                <regular-input
                  :value="modifyTransfer.refTransfered"
                  @input="modifyTransfer.refTransfered = $event"
                  type="text" :placeholder="$t('OrderInfo.transfered.refTransfer')"
                  class="col-lg-4 mb-2"/>
                <regular-input
                  :value="modifyTransfer.priceTransfered"
                  @input="modifyTransfer.priceTransfered = $event"
                  type="number" :placeholder="$t('OrderInfo.transfered.priceTransfer')"
                  class="col-lg-4 mb-2"/>
                <div class="col-sm-4">
                  <button class="btn btn-kne-orange w-100" @click="modifyTransferAction()">{{$t('OrderInfo.transfered.confirm')}}</button>
                </div>
              </div>
            </template>
          </table-element>

          <!-- Photos -->
          <div class="my-2" id="photo">
            <div v-if="transfer.historySync">
              <div class="card border pb-2 mb-2">
                <h5 class="kne-title">{{$t('OrderInfo.carPhotos.signatureDrop')}}</h5>
                <div v-if="checkHasFieldInObject(transfer.historySync, 'dropSignature')" class="mb-3 photo-container">
                  <img v-for="(entry, index) in transfer.historySync" :key="index" :src="entry.dropSignature" class="img-fluid mini" @click="openPreview($event.target.currentSrc, entry.dropName, entry.nightDropComment, entry['.key'])">
                </div>
                <p v-else class="text-center">{{$t('OrderInfo.carPhotos.no_drop_signature')}}</p>
              </div>

              <div class="card border pb-2 mb-2">
                <h5 class="kne-title">{{$t('OrderInfo.carPhotos.dropPhotos')}}</h5>
                <div v-if="checkHasFieldInObject(transfer.historySync, 'dropPhotos')" class="mb-3 photo-container">
                  <div v-for="(dispatch, index) in transfer.historySync" :key="index">
                    <img v-for="entry in dispatch.dropPhotos" :key="entry" :src="entry" class="img-fluid mini" @click="openPreview($event.target.currentSrc)">
                    <p class="text-center">
                      {{dispatch.nightDropComment}}
                    </p>
                  </div>
                </div>
                <p v-else class="text-center">{{$t('OrderInfo.carPhotos.no_drop_photos')}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <div>
      <!-- Status changed: TRANSIT -->
      <modal
        key="transitModal"
        v-if="isTransitModal"
        closable
        @close-request="close()"
        :title="$t('OrderInfo.modal.transit_status.title')"
      >
        <div>
          <div class="m-3">
            <label for="transit_location">{{$t('OrderInfo.modal.transit_status.location_label')}}<strong class="red_text">*</strong></label>
            <vue-google-autocomplete
              class="form-control placesSearch"
              id="transit_location"
              ref="AutocompleteSearchDelivery"
              :placeholder="$t('AddressBook.search_autocomplete')"
              v-on:placechanged="updateTransitLocation"
              :country="['ca', 'us']"
              :fields="autocompleteSearchFields">
            </vue-google-autocomplete>
          </div>

          <div class="mx-3">
            <create-note
              ref="createNoteJS"
              :label="$t('CreateNote.new_reason_title')"
              :notesList="notes"
              :orderId="getOrderId"
              :isAllowCreateNote="true"
              :placeholder="$t('CreateNote.reason_For_status_change')"
              @noteCreated="isNewNoteCreated = true"
            />
          </div>

          <div class="mx-3 mt-2 text-right">
            <p class="red_text">{{ errorMessage }}</p>
            <button id="submitButton" class="btn btn-kne-orange" @click="saveTransitLocation()">{{$t('OrderInfo.modal.confirm')}}</button>
          </div>
        </div>
      </modal>

      <!-- Status changed: CANCEL / ANNULER -->
      <modal
        key="cancelledModal"
        :title="$t('OrderInfo.modal.cancel_status.title')"
        v-if="isCancel"
        closable
        @close-request="close()"
      >
        <div>
          <div class="mx-3">
            <label for="cancel-reason"><i>{{$t('OrderInfo.modal.cancel_status.actionRequired')}}</i><strong class="red_text">*</strong></label>
            <regular-textarea
            :value="cancelReason"
            @input="cancelReason = $event"
            :placeholder="$t('OrderInfo.modal.cancel_status.inputPlaceholder')"
            id="cancel-reason"
            rows="3"/>
          </div>
          <div class="mt-2 mx-3 text-right">
            <p class="red_text">{{ errorMessage }}</p>
            <button class="btn btn-kne-orange" @click="saveCancelReason()">{{$t('OrderInfo.modal.confirm')}}</button>
          </div>
        </div>
      </modal>

      <!-- Status changed: FINISHED / TERMINÉE -->
      <modal
        key="finishedModal"
        :title="$t('OrderInfo.modal.finished_status.title')"
        v-if="isFinished"
        closable
        @close-request="close()"
      >
        <div>
          <div class="m-3">
            <label for="cancel-reason"><i>{{$t('OrderInfo.modal.finished_status.actionRequired')}}</i><strong class="red_text">*</strong></label>
            <regular-input
              :value="billInfo"
              @input="billInfo = $event"
              :placeholder="$t('OrderInfo.modal.finished_status.inputPlaceholder')"
              id="cancel-reason"
              class="form-group"
            />
          </div>

          <div class="mx-3">
            <create-note
              ref="createNoteJS"
              :label="$t('CreateNote.new_reason_title')"
              id="createNoteJS"
              :notesList="notes"
              :orderId="getOrderId"
              :isAllowCreateNote="true"
              :placeholder="$t('CreateNote.reason_For_status_change')"
              @noteCreated="isNewNoteCreated = true"
            />
          </div>

          <div class="mx-3 mt-2 text-right">
            <p class="red_text">{{ errorMessage }}</p>
            <button class="btn btn-kne-orange" @click="saveFinishedBill()">{{$t('OrderInfo.modal.confirm')}}</button>
          </div>
        </div>
      </modal>

      <!-- Status changed: The rest -> Opens Notes window -->
      <modal
        v-if="noteModal"
        key="notesModal"
        :title="$t('OrderInfo.modal.status_change_title') + translatedStatus"
        closable
        @close-request="close()"
      >
        <create-note
          class="mx-3"
          :showCreateNoteButton="true"
          :label="$t('CreateNote.new_reason_title')"
          :notesList="notes"
          :companyUID="companyUID"
          :username="userInfo.name"
          :orderId="getOrderId"
          :isAllowCreateNote="true"
          :placeholder="$t('CreateNote.reason_For_status_change')"
          @noteCreated="saveStatus"
        />
      </modal>

      <!-- Image preview -->
      <modal
        key="imgPrevwModal"
        v-if="preview"
        closable
        @close-request="close()"
      >
        <div class="text-center">
          <img :src="previewImgUrl" class="img-fluid medium">
          <p>{{ previewId }}</p>
          <p>{{ previewName }}</p>
          <p>{{ previewComment }}</p>
        </div>
      </modal>

      <!-- Modify -->
      <modal
        key="modifyModal"
        :title="$t('OrderInfo.modal.modification')"
        v-if="modify"
        @close-request="close()"
        closable
      >
        <div class="mx-3">
          <delivery-location-details
            ref="delivLocDetails"
            :order="order"
            :showBilling="true"
            :addressbook="addressbook"
            @sendSelectedEmails="updateSelectedEmails"
          />
          <h4 class="kne-title mx-2 mt-3">{{$t('OrderCurrent.modal.information')}}</h4>
          <div class="container-fluid">
            <div class="row pt-2">

              <div class="w-100 form-group mx-3" :class="{'document-date__item--mobile mt-2' : isScreenSmall}">
                <label for="vueDropzone" class="mt-0">{{$t('')}}</label>
                <custom-vue-dropzone
                  id="vueDropzone"
                  ref="myVueDropzone"
                  :dropzoneMessage="$t('OrderCurrent.modal.uploadRelease')"
                  @dropzoneFile="updateDropzoneFile"
                />
              </div>

              <div class="col-12 col-sm-6">
                <label for="numRef" class="mt-0">{{$t('OrderInfo.modal.reference')}}</label>
                <regular-input
                :value="order.numRef"
                @input="order.numRef = $event"
                type="text" :placeholder="$t('OrderInfo.modal.reference')" class="form-group"/>
              </div>

              <div class="col-12 col-sm-6">
                <label for="price" class="mt-0">{{$t('OrderInfo.modal.price')}}*</label>
                <regular-input-number
                id="orderPrice"
                :value="order.price"
                @input="order.price = $event; formatPrice()"
                type="number" :placeholder="$t('OrderInfo.modal.price')" class="form-group"/>
              </div>

              <div class="col-12 col-sm-6">
                <label for="vin" class="mt-0">{{$t('OrderInfo.modal.VIN')}}</label>
                <regular-input
                id="vin"
                :value="order.vin"
                @input="order.vin = $event"
                type="text" :placeholder="$t('OrderInfo.modal.VIN')" class="form-group"/>
              </div>

              <div class="col-12 col-sm-6">
                <label for="year" class="mt-0">{{$t('OrderInfo.modal.year')}}</label>
                <regular-input
                id="year"
                :value="order.year"
                @input="order.year = $event"
                type="text" :placeholder="$t('OrderInfo.modal.year')" class="form-group"/>
              </div>

              <div class="col-12 col-sm-6">
                <label for="make" class="mt-0">{{$t('OrderInfo.modal.make')}}</label>
                <regular-input
                id="make"
                :value="order.make"
                @input="order.make = $event"
                type="text" :placeholder="$t('OrderInfo.modal.make')" class="form-group"/>
              </div>

              <div class="col-12 col-sm-6">
                <label for="model" class="mt-0">{{$t('OrderInfo.modal.model')}}</label>
                <regular-input
                id="model"
                :value="order.model"
                @input="order.model = $event"
                type="text" :placeholder="$t('OrderInfo.modal.model')" class="form-group"/>
              </div>

              <div class="col-12 col-sm-6">
                <label for="billing" class="mt-0">{{$t('OrderInfo.information.billing')}}</label>
                <regular-input
                id="billing"
                :value="order.billNum"
                @input="order.billNum = $event"
                type="text" :placeholder="$t('OrderInfo.information.billing')" class="form-group"/>                
              </div>

              <div class="col-12">
                <label for="comment" class="mt-0">{{$t('OrderInfo.modal.comment')}}</label>
                <regular-textarea
                id="comment"
                :value="order.comment"
                @input="order.comment = $event"
                :placeholder="$t('OrderInfo.modal.comment')" class="form-group" rows="6"/>
              </div>

              <div class="col-12">
                <label for="datePromis" class="mt-0">{{$t('OrderPending.orderTab.datePromis')}}</label>
                <regular-input
                  id="datePromis"
                  :value="order.datePromis"
                  @input="order.datePromis =  $event"
                  type="date" :placeholder="$t('OrderPending.orderTab.datePromis')" class="form-group"
                />
              </div>

            </div>
          </div>

          <div class="col-12">
              <span class="red-text">{{feedbackMessage}}</span>
            <button id="modifyBtn" class="btn btn-kne-orange w-100 form-group" :disabled="!formCompleted" @click="modifyOrder()">{{$t('OrderInfo.modal.modify')}}</button>
          </div>

          <div class="container-fluid">
            <div class="row">
              <regular-select
              :value="taxes"
              @change="taxes = $event"
              :placeholder="$t('OrderInfo.modal.tax')" class="col-12 col-sm-6 form-group">
              <option v-for="province in $store.state.provinces" :key="province" :value="province">{{province}}</option>
              </regular-select>
              <regular-input
              :value="order.billingDate"
              @input="order.billingDate = formatDate($event)"
              type="date" :placeholder="$t('OrderInfo.modal.date')" class="col-12 col-sm-6 form-group"/>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <regular-textarea
                :value="taxesComment"
                @input="taxesComment = $event"
                :placeholder="$t('OrderInfo.modal.taxesComment')" class="col-12 form-group" rows="6"/>
            </div>
          </div>
          <div class="col-12">
            <a target="_blank" :href="'https://www.sageone.com/oauth2/auth/central?filter=apiv3.1&response_type=code&client_id=3ff1477e6ec457b7df62&redirect_uri=https://systems.keepneye.com/api4/SageoneToken&scope=full_access&state=' + $route.query.orderId ">
              <button :disabled="taxes === '' || !order.sageID || order.price === '' || order.billingDate === ''" class="btn btn-kne-orange mb-2 w-100" @click="modifyOrder()">{{$t('OrderInfo.modal.billing.title')}}</button>
            </a>
          </div>
        </div>
      </modal>

      <!-- Dispatch -->
      <short-dispatch-modal
        v-if="dispatch"
        ref="shortDispatchModal"
        :arrOfOrder="arrOrderShortDispatch"
        :liste="listOrdered"
        :addressbook="addressbook"
        :priceOrderLink="setPriceOrderLink(getOrderId, this.originalOrder)"
        :isOpen="dispatch"
        :isOrderNbClickable="false"
        @closeModal="dispatch = false; clearData()"
        @close-request="dispatch = false; clearData()"
        @clearSelected="''"
      />

      <!-- Send -->
      <modal
        v-if="send"
        key="sendModal"
        :title="$t('OrderInfo.sidebar.send')"
        @close-request="close()"
        closable
      >
        <!-- Send-->
        <div class="mx-2">
          <div class="">
            <regular-select
              :value="sendOrder.carrier"
              @change="sendOrder.carrier = $event"
              :placeholder="$t('OrderInfo.modal.carrier')" class="border m-2">
              <option v-for="(carriers, index) in carriersOrdered" :key="index" :value="carriers['.key']">{{ carriers['.value'] }}</option>
            </regular-select>
          </div>

          <delivery-location-details
            ref="delivLocDetails"
            :order="order"
            :showBilling="false"
            :addressbook="addressbook"
            @sendSelectedEmails="updateSelectedEmails"
          />

          <div class="mt-3 px-0">
            <h4 class="kne-title">{{$t('OrderCurrent.modal.information')}}</h4>
            <div class="flex f_row">
              <div class="w-50">
                <regular-input
                  :value="order.numRef"
                  @input="order.numRef = $event"
                  type="text" :placeholder="$t('OrderInfo.modal.reference')"
                  class="mr-2"
                />
              </div>
              <div class="w-50 flex f_row">
                <hover-tool-tip
                v-show="isBrunoAccount"
                class="pt-2 pl-2 pr-1"
                :text="$t('OrderCurrent.modal.dispatch.price_tooltip') + ' (' + (calculateMaxInputPrice(originalOrder)) + '$)'"
                :top="true"
                :right="true"
                :clickable="false"
                />
                <regular-input
                v-show="!isBrunoAccount"
                id="orderPrice"
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="$t('OrderInfo.modal.price')" class="ml-2 w-100"/>
                <regular-input
                v-show="isBrunoAccount"
                id="orderPrice"
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="(calculateMaxInputPrice(originalOrder)) + '$ Max'" class="ml-2 w-100"/>
              </div>
            </div>

            <regular-textarea
            :value="order.comment"
            @input="order.comment = $event"
            :placeholder="$t('OrderInfo.modal.comment')" class="mt-2" rows="6"/>
            <button class="btn btn-kne-orange my-2 w-100" :disabled="!sendFormFilled" @click="onSendOrderToTransporter()">{{$t('OrderInfo.modal.send')}}</button>
          </div>
        </div>
      </modal>

      <!-- Inspection -->
      <modal
        key="inspModal"
        :title="$t('OrderInfo.sidebar.inspection')"
        v-if="inspection"
        @close-request="close()"
        closable
      >
        <div>
          <div class="col-12">
            <div class="row">
              <regular-select
              :value="inspectionOrder.key"
              @change="inspectionOrder.key = $event"
              :placeholder="$t('OrderInfo.modal.choose')" class="col-12 col-sm-6 form-group">
                <option v-for="(order, historyKey) in originalOrder.historySync" :key="historyKey">{{historyKey}}</option>
              </regular-select>
              <div class="col-12 col-sm-6">
                <button class="btn btn-kne-orange w-100 form-group" :disabled="!orderChosen" @click="generate()">{{$t('OrderInfo.modal.generate')}}</button>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <regular-input
              :value="inspectionOrder.email"
              @input="inspectionOrder.email = $event"
              type="text" :placeholder="$t('OrderInfo.modal.email')" class="col-12 col-sm-6"/>
              <div class="col-12 col-sm-6">
                <button class="btn btn-kne-orange w-100 form-group" :disabled="!emailEntered" @click="sendBolTo()">{{$t('OrderInfo.modal.BOL')}}</button>
              </div>
              <div class="ml-auto col-sm-6">
                <button class="btn btn-kne-orange w-100 form-group" @click="mergeBody()">{{$t('OrderInfo.modal.merge')}}</button>
              </div>
            </div>
          </div>

        </div>
      </modal>

      <!-- Send document email -->
      <modal
        key="inspModal"
        :title="$t('OrderInfo.sidebar.send_docs')"
        v-if="isSendDocsModal"
        @close-request="clearSendDocData(); isSendDocsModal = false"
        closable
      >
        <div class="mx-2">
          <div class="doc_info_wrapper">
            <div class="doc_info_container mx-2">
              <h3 class="kne-subtitle">{{$t('OrderInfo.modal.send_doc.vehicle_info')}}</h3>
              <p><strong>{{$t('OrderInfo.information.make')}}:</strong> {{ originalOrder.make || $t('OrderInfo.missing_info') }}</p>
              <p><strong>{{$t('OrderInfo.information.model')}}:</strong> {{ originalOrder.model || $t('OrderInfo.missing_info') }}</p>
              <p><strong>{{$t('OrderInfo.information.year')}}:</strong> {{ originalOrder.year || $t('OrderInfo.missing_info') }}</p>
              <p><strong>{{$t('OrderInfo.information.VIN')}}:</strong> {{ originalOrder.vin || $t('OrderInfo.missing_info') }}</p>
            </div>

            <div class="doc_info_container">
              <h3 class="kne-subtitle">{{$t('OrderInfo.modal.send_doc.delivery_info')}}</h3>
              <div class="content-wrapper row mx-0">
                <div class="mr-2">
                  <h5><strong>{{$t('AddressInfo.name')}} ({{$t('AddressInfo.billing')}}) :</strong> {{ originalOrder.payerName || $t('OrderInfo.missing_info') }} </h5>
                  <p><strong>{{$t('AddressInfo.address')}}:</strong> {{ originalOrder.payerAddress || $t('OrderInfo.missing_info') }}</p>
                  <p><strong>{{$t('AddressInfo.country')}}:</strong> {{ originalOrder.payerCountry || $t('OrderInfo.missing_info') }}</p>
                  <p><strong>{{$t('AddressInfo.province')}}:</strong> {{ originalOrder.payerProvince || $t('OrderInfo.missing_info') }}</p>
                  <p><strong>{{$t('AddressInfo.city')}}:</strong> {{ originalOrder.payerCity || $t('OrderInfo.missing_info') }}</p>
                  <p><strong>{{$t('AddressInfo.postcode')}}:</strong> {{ originalOrder.payerPostcode || $t('OrderInfo.missing_info') }}</p>
                </div>
              </div>
            </div>
          </div>

          <button @click="isShowPicturesInSendModal = !isShowPicturesInSendModal" class="btn-kne-orange btn mb-2">{{$t('OrderInfo.modal.send_doc.show_photos')}} <strong>( {{countPhotos}} ) </strong></button>
          <transition name="fade">
            <div v-show="isShowPicturesInSendModal">
              <!-- Photos -->
              <div class="my-2" id="photo">
                <div class="card border pb-2 mb-2">
                  <h5 class="kne-title">{{$t('OrderInfo.carPhotos.photos')}}</h5>
                  <div class="photo-container">
                    <img v-for="photoUrl in originalOrder.photos" :key="photoUrl" :src="photoUrl" class="img-fluid mini" @click="openPreview($event.target.currentSrc)">
                  </div>
                  <p v-if="!order.photos" class="text-center">{{$t('OrderInfo.carPhotos.no_vehicle_photos')}}</p>
                </div>

                <div class="card border pb-2 mb-2">
                  <h5 class="kne-title">{{$t('OrderInfo.carPhotos.bodyPhotos')}}</h5>
                  <div class="photo-container">
                    <img v-for="photoUrl in originalOrder.bodyPhotos" :key="photoUrl" :src="photoUrl" class="img-fluid mini" @click="openPreview($event.target.currentSrc)">
                  </div>
                  <p v-if="!order.bodyPhotos" class="text-center">{{$t('OrderInfo.carPhotos.no_body_photos')}}</p>
                </div>

                <div v-if="originalOrder.historySync">
                  <div class="card border pb-2 mb-2">
                    <h5 class="kne-title">{{$t('OrderInfo.carPhotos.dropPhotos')}}</h5>
                    <div v-if="checkHasFieldInObject(originalOrder.historySync, 'dropPhotos')" class="mb-3 photo-container">
                      <div v-for="(dispatch, index) in originalOrder.historySync" :key="index">
                        <img v-for="entry in dispatch.dropPhotos" :key="entry" :src="entry" class="img-fluid mini" @click="openPreview($event.target.currentSrc)">
                        <p class="text-center">
                          {{dispatch.nightDropComment}}
                        </p>
                      </div>
                    </div>
                    <p v-else class="text-center">{{$t('OrderInfo.carPhotos.no_drop_photos')}}</p>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <hr>
          <div>
            <regular-input class="my-2" :value="documentEmailTarget" @input="documentEmailTarget = $event" :placeholder="$t('OrderInfo.modal.send_doc.email_placeholder') + '*'"/>
            <regular-input class="my-2" :value="documentMessage" @input="documentMessage = $event" :placeholder="$t('OrderInfo.modal.send_doc.message_placeholder')"/>
            <custom-vue-dropzone
              id="vueDropzone"
              ref="myVueDropzone"
              :dropzoneMessage="$t('OrderInfo.modal.send_doc.file_dropzone')"
              :maxFile="3"
              @dropzoneFile="updateDropzoneFile"
              class="mb-2"
            />
            <p class="red-text">{{ feedbackMessage }}</p>
            <button class="btn btn-kne-orange" @click="onSendDocumentEmail(originalOrder, documentEmailTarget, documentMessage, dropzoneFile)">{{$t('General.send')}}</button>
          </div>

        </div>
      </modal>

      <!-- Chat -->
      <modal
        key="chatModal"
        v-if="chat"
        @close-request="close()"
        :title="$t('CreateNote.note_list_title')"
        closable
      >
        <create-note
          class="m-3"
          :showCreateNoteButton="true"
          :showList="true"
          :notesList="loadedNotes"
          :companyUID="companyUID"
          :username="userInfo.name"
          :orderId="getOrderId"
          :isAllowCreateNote="isAllowCreateNote"
          :placeholder="$t('CreateNote.note_message')"
        />
      </modal>

      <!-- Reprocess -->
      <reprocess-order-modal
        key="reprocessModal"
        v-if="isReprocessModal"
        :orderId="getOrderId"
        :originalOrder="originalOrder"
        :isArchived="returnIsOrderArchived"
        @closeModal="isReprocessModal = false"
      />

      <!-- Distributed History -->
      <distributed-history-modal
        key="distributed"
        ref="distModal"
        :isOpen="isDistributedModal"
        :priceOrderLink="setPriceOrderLink(getOrderId, this.originalOrder)"
        @closeModal="isDistributedModal = false; close()"
      />
    </div>

  </div>
</template>

<script>
import Modal from '../module/interface-components/Modal.vue'
import regularInput from '../module/basic-components/regularInput.vue'
import regularInputNumber from '../module/basic-components/regularInputNumber.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import RegularStatusSelect from '../module/basic-components/RegularSelectStatus.vue'
import CustomVueDropzone from '../module/special-components/Custom-packages/Custom-VueDropzone.vue'

import TransferHistory from '../module/special-components/Other-components/TransferHistory.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
import ShortDispatchModal from '../module/special-components/Modal-templates/ShortDispatch-modal.vue'
import DistributedHistoryModal from '../module/special-components/Modal-templates/DistributedHistory-modal.vue'
import ReprocessOrderModal from '../module/special-components/Modal-templates/ReprocessOrder-modal.vue'
import OrderActionBar from '../module/special-components/Other-components/OrderActionBar.vue'
import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
import HoverToolTip from '../module/basic-components/HoverToolTip.vue'
import {db, dbArchives2} from '../../firebase'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import _ from 'lodash'
import ChatPage from '../module/interface-components/ChatPage.vue'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import DeliveryLocationDetails from '../module/special-components/Other-components/DeliveryLocationDetails.vue'
import TicketButton from '../module/interface-components/TicketButton.vue'
import CreateNote from '../module/special-components/Other-components/CreateNote.vue'
import HistoryPage from '../module/special-components/Other-components/HistoryPage.vue'

export default {
  name: 'OrderInfo',
  components: {
    Modal,
    regularInput,
    regularInputNumber,
    regularSelect,
    regularTextarea,
    OrderActionBar,
    vueDropzone: vue2Dropzone,
    regularDatalistDriver,
    SidebarToggleButton,
    ChatPage,
    VueGoogleAutocomplete,
    DeliveryLocationDetails,
    TicketButton,
    CreateNote,
    HoverToolTip,
    ReprocessOrderModal,
    DistributedHistoryModal,
    HistoryPage,
    RegularStatusSelect,
    CustomVueDropzone,
    ShortDispatchModal,
    TableElement,
    LoadingRender,
    TransferHistory
  },

  data () {
    return {
      documentEmailTarget: '',
      documentMessage: '',
      documentFiles: {},
      isShowPicturesInSendModal: false,
      isSendDocsModal: false,
      arrOrderShortDispatch: [],
      isShowTransferHistory: false,
      chat: false,
      modify: false,
      dispatch: false,
      inspection: false,
      send: false,
      modifyDelivery: false,
      preview: false,
      carrier: '',
      deliveryOrder: '',
      deliveryInvoice: '',
      deliveryChauffeur: '',
      taxes: '',
      taxesComment: '',
      modifyTransfer: {
        refTransfered: '',
        priceTransfered: ''
      },
      inspectionOrder: {
        email: '',
        key: ''
      },
      sendOrder: {
        carrier: '',
        carrierName: ''
      },
      dispatchOrder: {
        chauffeur: '',
        chauffeurName: ''
      },
      order: {
        billNum: '',
        billingDate: '',
        comment: '',
        datePromis: '',
        docs: '',
        latitude: 0.001,
        longitude: 0.001,
        make: '',
        model: '',
        nbDispatch: 0,
        numRef: '',
        payer: '',
        payerAddress: '',
        payerCity: '',
        payerContact: '',
        payerFax: '',
        payerName: '',
        payerPhone: '',
        payerEmail: '',
        payerPostcode: '',
        payerCountry: '',
        payerProvince: '',
        price: '',
        receiver: '',
        receiverAddress: '',
        receiverCity: '',
        receiverContact: '',
        receiverFax: '',
        receiverName: '',
        receiverLat: 0,
        receiverLong: 0,
        receiverPhone: '',
        receiverEmail: '',
        receiverPostcode: '',
        receiverCountry: '',
        receiverProvince: '',
        receiverPlaceId: '',
        status: '',
        source: '',
        transmitter: '',
        transmitterAddress: '',
        transmitterCity: '',
        transmitterContact: '',
        transmitterFax: '',
        transmitterName: '',
        transmitterLat: 0,
        transmitterLong: 0,
        transmitterPhone: '',
        transmitterEmail: '',
        transmitterPostcode: '',
        transmitterCountry: '',
        transmitterProvince: '',
        transmitterPlaceId: '',
        transpCigle: '',
        transpName: '',
        vin: '',
        year: '',
        taxes: ''
      },
      datalist: {
        pickup: '',
        pickupUid: '',
        delivery: '',
        deliveryUid: '',
        billing: '',
        billingUid: ''
      },
      previewImgUrl: '',
      previewName: '',
      previewComment: '',
      previewId: '',
      note: {
        name: '',
        text: '',
        date: ''
      },
      reversedNotes: [],
      notes: [],
      paginate: ['reversedNotes'],
      liste: [],
      carriers: [],
      addressbook: [],
      autocompleteSearchFields: ['address_components', 'adr_address', 'formatted_address', 'formatted_phone_number', 'geometry', 'id', 'name', 'place_id', 'type', 'vicinity'],
      // 'utc_offset_minutes', 'url', 'photo', 'business_status', 'icon', 'scope', 'alt_id',
      isTransitModal: false,
      isCancel: false,
      isFinished: false,
      isTransitLocationFilled: false,
      cancelReason: '',
      billInfo: '',
      noteModal: false,
      newSelectedStatus: '',
      isNewNoteCreated: false,
      errorMessage: '',
      priceOrderLink: [],
      feedbackMessage: '',
      isReprocessModal: false,
      isDistributedModal: false,
      statusType: {
        dispatch: 'Dispatch'
      },
      selectedContactEmails: [],
      fieldsTRF: [
       {
         text: this.$t('OrderInfo.transfered.carrier'),
         type: 'transpName',
         value: ''
       },
       {
         text: this.$t('OrderInfo.transfered.reference'),
         type: 'orderRef',
         value: ''
       },
       {
         text: this.$t('OrderInfo.transfered.order'),
         type: '.key',
         value: ''
       },
       {
         text: this.$t('OrderInfo.transfered.VIN'),
         type: 'vin',
         value: ''
       },
       {
         text: this.$t('OrderInfo.transfered.date'),
         type: 'creationDate',
         value: ''
       },
       {
         text: this.$t('OrderInfo.transfered.pickup'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('OrderInfo.transfered.delivery'),
         type: 'receiverName',
         value: ''
       },
       {
         text: this.$t('OrderInfo.transfered.status'),
         type: 'status',
         value: ''
       },
       {
         text: this.$t('OrderInfo.transfered.refTransfer'),
         type: 'refTransfered',
         value: ''
       },
       {
         text: this.$t('OrderInfo.transfered.priceTransfer'),
         type: 'priceTransfered',
         value: ''
       }
      ],
      // (OrderInfo-Transfer-drop-history/Render)
      showHistory: false,
      isAllowCreateNote: false,
      dropzoneFile: ''
    }
  },

  created () {
    this.$store.state.isSidebarOpen = false
    this.isScreenSmall = window.innerWidth < 800
    let id = this.companyUID

    const dbPathOrder = this.setDbPath('order')
    const dbPathNote = this.setDbPath('note')

    this.setOrderInfo(dbPathOrder, dbPathNote)
    this.$bindAsArray('carriers', db.ref('users/transporters/' + id + '/liste'))
    this.$bindAsArray('liste', db.ref('database/transporter/' + id + '/liste'))
    document.getElementById('app').scrollIntoView()
  },

  methods: {
    openSendDocs () {
      this.clearSendDocData()
      this.isSendDocsModal = true
    },

    onSendDocumentEmail (originalOrder, documentEmailTarget, messageNote, documentFile) {
      if (documentEmailTarget === '') {
        this.feedbackMessage = this.$t('OrderInfo.modal.send_doc.missing_email_target')
        return
      }

      let messageTrackerUrl = this.setTrackerUrl(originalOrder.codeSecret)
      // let messageOrderPhotos = this.setOrderPhotoHTML(originalOrder.photos)
      // let messageBodyPhotos = this.setBodyPhotoHTML(originalOrder.bodyPhotos)
      // let messageDropPhotos = this.setDropPhotoHTML(originalOrder.historySync)
      let message = this.setDocumentMessage(originalOrder, messageNote, messageTrackerUrl)

      let documentTitle = this.setDocumentTitle(originalOrder)
      let documentFileName = this.setDocumentFileName(documentFile)
      let documentMailOptions = this.setDocumentMailOptions(documentEmailTarget, documentFileName, message, documentTitle, documentFile)

      db.ref('email-request9').push().set(documentMailOptions)
      this.clearSendDocData()
      this.isSendDocsModal = false
      alert(`${this.$t('OrderInfo.modal.send_doc.sent_successfully')} ${documentEmailTarget}`)
    },

    setOrderPhotoHTML (photos) {
      let photoHTML = ''

      if (!this.checkIsUndefined(photos)) {
        photoHTML = '<p>Vehicle photos / Photos du véhicule:</p>'
        photos.forEach(photo => {
          photoHTML += `<img style="width: 160px;" src="${photo}"> `
        })
      }

      return photoHTML
    },

    setBodyPhotoHTML (photos) {
      let photoHTML = ''

      if (!this.checkIsUndefined(photos)) {
        photoHTML = '<p>Vehicle body photos / Photos de la carrosserie du véhicule:</p>'
        photos.forEach(photo => {
          photoHTML += `<img style="width: 160px;" src="${photo}"> `
        })
      }

      return photoHTML
    },

    setDropPhotoHTML (photos) {
      let photoHTML = ''

      if (!this.checkIsUndefined(photos)) { // Check if the order has a historySync (Where the drop photos are located)
        let historyKeys = Object.keys(photos) // Map all the keys into an array so we can itterate through each history
        let hasDropPhotos = false // Used to check if setting an initial string later on is needed

        historyKeys.forEach(key => {
          if (photos[key].hasOwnProperty('dropPhotos')) {
            hasDropPhotos = true

            photos[key].dropPhotos.forEach(photo => {
              photoHTML += `<img style="width: 160px;" src="${photo}"> `
            })
          }
        })

        if (hasDropPhotos) photoHTML = `<p>Drop photos / Photos de la livraison:</p> ${photoHTML}`
      }

      return photoHTML
    },

    setTrackerUrl (trackerCode) {
      let trackerUrl = ''

      let trackerUrlSplit = trackerCode.split('-')
      trackerUrlSplit.splice(0, 1) // Removes the first part of the file name
      trackerUrl = `https://keep-n-eye-quick.web.app/#/tracker?transporterUid=${this.companyUID}&trackerId=${trackerUrlSplit.join('-')}`

      return trackerUrl
    },

    setDocumentMessage (originalOrder, documentNote, messageTrackerUrl) {
      let message = ''

      message =
      `
        <p> Hello, here are the details of the delivery for the following vehicle: [<strong>${originalOrder.make} - ${originalOrder.model} - ${originalOrder.year}</strong>]</p>
        <p> This e-mail has been sent from the transporter of your vehicle to give you details about the current order.</p>
        <p> You will be able to find its billing location, a link to track your order and pictures taken to document the state of the vehicle.</p>
        <p> A file and/or a message may be found if they have been provided by the transporter.</p>
        <p> Thank you for using our services.</p>
        <p> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - </p>
        <p> Bonjour, voici la livraison en detail du véhicule suivant: [<strong>${originalOrder.make} - ${originalOrder.model} - ${originalOrder.year}</strong>]</p>
        <p> Ce courriel électronique a été envoyé par le transporteur de votre véhicule pour vous donner des détails de la commande.</p>
        <p> Vous y trouverez ci-dessous l'endroît de facturation, un lien pour repérez votre commande et des photos prises pour documenter l'état du véhicule.</p>
        <p> Un fichier et/ou un message peut être attaché si le transporteur en a fournie.</p>
        <p> Merci d'avoir fait affaire avec nous.</p>
        <p> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - </p>

        <p> Note from the transporter / Note du transporteur: ${documentNote || 'Aucune note / No note'} </p>

        <p> Billing information / Information de facturation:
        ${originalOrder.payerName}: ${originalOrder.payerAddress}, ${originalOrder.payerCountry}, ${originalOrder.payerProvince}, ${originalOrder.payerCity}, ${originalOrder.payerPostcode}
        </p>

        <p> Track all the information of this order with this link / Repérez toutes les informations de cette commande avec ce lien: <a href="${messageTrackerUrl}">${messageTrackerUrl}</a></p>
      `

      return message
    },

    setDocumentTitle (originalOrder) {
      let title = `Transport information of the vehicle: ${originalOrder.vin} - ${originalOrder.make}, ${originalOrder.model}, ${originalOrder.year}`
      return title
    },

    setDocumentFileName (file) {
      let documentName = ''

      if (file.length > 0) {
        let nameSplit = file.split('_')
        nameSplit.splice(0, 1) // Removes the first part of the file name (AWS string identifier stuff)
        documentName = nameSplit.join(' ')
      }

      return documentName
    },

    setDocumentMailOptions (target, filename, message, title, file) {
      let mailOptions = {}

      if (filename.length > 1) {
        mailOptions = {
          to: target,
          message: message,
          title: title,
          attachments: [{
            filename: filename || '',
            path: file || ''
          }]
        }
      } else {
        mailOptions = {
          to: target,
          message: message,
          title: title
        }
      }

      return mailOptions
    },

    clearSendDocData () {
      this.documentEmailTarget = ''
      this.documentMessage = ''
      this.feedbackMessage = ''
      this.dropzoneFile = {}
    },

    // ^ End of document send functions  ^ //

    /** I have to use the extra array variable @arrOrderShortDispatch and this method
     * because there is a render bug when changing
     * the location inside "Sidebar -> Distribuer -> Address".
     * The @transmitterName won't update after saving the new location.
     */
    getOrderArr () {
      this.arrOrderShortDispatch = []
      let order = {...this.order}
      order.orderNumber = this.getOrderId
      this.arrOrderShortDispatch.push(order)
    },

    checkHasFieldInObject (object, fieldName) {
      let hasField = false

      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          if (!this.checkIsUndefined(object[key][fieldName])) hasField = true
        }
      }

      return hasField
    },

    // (OrderInfo-Transfer-drop-history/Render)
    forceUpdate () {
      this.showHistory = !this.showHistory
    },

    setDbPath (pathType) {
      const refOrder = `database/transporter/${this.companyUID}/deliveries/${this.getOrderId}`
      let dbPathOrder = ''
      let dbPathNote = ''

      if (this.$route.query.archive && this.$route.query.archivedOrder) {
        dbPathOrder = dbArchives2.ref(refOrder)
        dbPathNote = dbArchives2.ref(refOrder).child('notes')
      } else if (!this.$route.query.archive && this.$route.query.archivedOrder) {
        dbPathOrder = dbArchives2.ref(refOrder)
        dbPathNote = dbArchives2.ref(refOrder).child('notes')
      } else {
        dbPathOrder = db.ref(refOrder)
        dbPathNote = db.ref(refOrder).child('notes')
      }

      if (pathType === 'order') return dbPathOrder
      if (pathType === 'note') return dbPathNote
    },

    async setOrderInfo (dbPathOrder, dbPathNote) {
      this.$bindAsObject('originalOrder', dbPathOrder, null, async function (snap) {
        this.$bindAsArray('notes', dbPathNote)
        this.order = snap.val()
        var o = this.order
        if (o.transmitterProvince === undefined) this.$set(this.order, 'transmitterProvince', '')
        if (o.transmitterCountry === undefined) this.$set(this.order, 'transmitterCountry', '')
        if (o.receiverProvince === undefined) this.$set(this.order, 'receiverProvince', '')
        if (o.receiverCountry === undefined) this.$set(this.order, 'receiverCountry', '')
        if (o.payerProvince === undefined) this.$set(this.order, 'payerProvince', '')
        if (o.payerCountry === undefined) this.$set(this.order, 'payerCountry', '')
        if (o.billingDate === undefined) this.$set(this.order, 'billingDate', this.formatDate(Date.now()))
        if (snap.val().idTransfer && snap.val().isTransfered) {
          // Needed if the original transporter finished the order.
          // Fetch from original transporter's archived orders instead of current orders
          await this.$bindAsObject('transfer', db.ref('database/transporter/' + snap.val().isTransfered + '/deliveries/').child(snap.val().idTransfer), null, async function (transferSnap) {
            if (transferSnap.val() === null) this.$bindAsObject('transfer', dbArchives2.ref('database/transporter/' + snap.val().isTransfered + '/deliveries/').child(snap.val().idTransfer))
          })

           // Same as comment above
          await this.$bindAsArray('transferNotes', db.ref('database/transporter/' + snap.val().isTransfered + '/deliveries/').child(snap.val().idTransfer).child('notes'), null, async function (transferNotesSnap) {
            if (transferNotesSnap.val() === null) this.$bindAsArray('transferNotes', dbArchives2.ref('database/transporter/' + snap.val().isTransfered + '/deliveries/').child(snap.val().idTransfer).child('notes'))
          })

          if ((this.$route.query.archive || !this.$route.query.archive) && this.$route.query.archivedOrder) {
            this.$bindAsObject('transfer2', dbArchives2.ref('database/transporter/' + snap.val().isTransfered + '/deliveries/').child(snap.val().idTransfer))
            this.$bindAsArray('transfer2Notes', dbArchives2.ref('database/transporter/' + snap.val().isTransfered + '/deliveries/').child(snap.val().idTransfer).child('notes'))
          }
        }
      })
    },

    getNotesText (order) {
      let text = ''

      if (this.checkIsUndefined(order.notes)) text += this.$t('OrderInfo.no_notes')
      else {
        text = this.$t('OrderCurrent.notes')
        for (const noteKey in order.notes) {
          if (Object.hasOwnProperty.call(order.notes, noteKey)) {
            const element = order.notes[noteKey]
            text += `<br> ${element.text} `
          }
        }
      }

      return text
    },

    /** From @emits 'sendSelectedEmails' @DeliveryLocationDetails */
    updateSelectedEmails (selectedEmails) {
      this.selectedContactEmails = selectedEmails
    },

    /** When @dropDate doesn't exist in the last history key, allow the user to set the @dropDate to the last history key */
    onChangeDropDate (orderId, order) {
      const distModalRef = this.$refs.distModal
      const keys = distModalRef.getObjectKeys(order.historySync)
      const lastKey = distModalRef.getLastArrayData(keys)

      distModalRef.setOrder(order)
      distModalRef.setOrderId(orderId)
      distModalRef.setHistoryKey(lastKey)

      this.isDistributedModal = true
    },

    /** Used to set the red (false) or green (true) buttons in Short Dispatch */
    checkHistory (orderId, history) {
      const isTruthy = this.$refs.distModal.checkHistory(history)

      if (!isTruthy) this.onChangeDropDate(orderId, this.originalOrder)
    },

    onReprocessOrder () {
      if (this.returnIsOrderArchived) this.openReprocessModal()
    },

    openReprocessModal () {
      this.isReprocessModal = true
    },

    sortAsc (list) {
      return list.sort((a, b) => {
        var A = a['.value'].toUpperCase()
        var B = b['.value'].toUpperCase()
        if (A < B) { return -1 }
        if (A > B) { return 1 }
        return 0
      })
    },

    updateDropzoneFile (file) {
      this.dropzoneFile = file
    },

    generate () {
      var id = this.companyUID
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/bol/create/' + id + '/' + this.getOrderId + '/' + this.inspectionOrder.key).then((response) => {
        window.open(response.data.url)
      }).catch((error) => console.log(error))
    },

    sendBolTo () {
      var id = this.companyUID
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/bol/send/' + id + '/' + this.getOrderId + '/' + this.inspectionOrder.key + '/' + this.inspectionOrder.email).then((response) => {
        this.close()
      }).catch((error) => console.log(error))
    },

    mergeBody () {
      for (const key in this.originalOrder.historySync) {
        if (Object.hasOwnProperty.call(this.originalOrder.historySync, key)) {
          const history = this.originalOrder.historySync[key]
          if (!history.body) db.ref('database/transporter/' + this.companyUID + '/history/' + this.getOrderId).child(key).update({body: this.findLastBody.body, bol: null})
        }
      }

      this.close()
    },

    validateEmail (email) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) return true
      else return false
    },

    close () {
      this.errorMessage = ''
      this.isTransitModal = false
      this.isTransitLocationFilled = false
      this.isNewNoteCreated = false
      this.isSendDocsModal = false

      this.noteModal = false
      this.chat = false
      this.modify = false
      this.modifyDelivery = false
      this.dispatch = false
      this.send = false
      this.inspection = false
      this.preview = false
      this.isCancel = false
      this.isFinished = false

      this.clearData()
    },

    clearData () {
      if (!this.originalOrder.sageID) this.order.sageID = ''
      for (let attr in this.order) {
        this.order[attr] = ''
      }
      for (let attr in this.originalOrder) {
        this.order[attr] = this.originalOrder[attr]
      }
      for (let attr in this.datalist) {
        this.datalist[attr] = ''
      }
    },

    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },

    formatDate (date) {
      var fdate = new Date(date)
      return fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)
    },

    openPreview (url, name, comment, key) {
      this.previewImgUrl = url
      this.preview = true
      key ? this.previewId = key : this.previewId = ''
      name ? this.previewName = name : this.previewName = ''
      comment ? this.previewComment = comment : this.previewComment = ''
    },

    openSend () {
      this.initializeAddressbook()
      this.send = true
      this.order.price = ''
      this.order.numRef = ''
      this.order.comment = ''
      this.carrier = ''
      this.sendOrder.carrier = ''
    },

    initializeAddressbook () {
      var id = this.companyUID

      db.ref('database/transporter/' + id + '/carnet').once('value').then((snap) => {
        let addressbookArray = []

        snap.forEach((element) => {
          let item = element.val()
          item.key = element.key
          addressbookArray.push(item)
        })

        this.addressbook = addressbookArray
      })
    },

    openInspection () {
      this.inspection = true
      this.inspectionOrder.key = ''
      this.inspectionOrder.email = ''
    },

    openDispatch () {
      this.initializeAddressbook()
      this.dispatch = true
      this.order.price = ''
      this.order.numRef = ''
      this.order.comment = 'Client/Customer: ' + this.order.payerName
      if (this.userInfo.driverComment) this.order.comment += '\n' + this.originalOrder.comment
      this.dispatchOrder.chauffeur = ''
      this.dispatchOrder.chauffeurName = ''
      this.priceOrderLink = []
      this.setPriceOrderLink(this.getOrderId, this.originalOrder)
      this.getOrderArr()
    },

    openModification () {
      this.initializeAddressbook()
      this.modify = true
      this.order.price = this.originalOrder.price
      this.order.numRef = this.originalOrder.numRef
      this.order.comment = this.originalOrder.comment
      this.priceOrderLink = []
      this.dropzoneFile = ''
      this.setPriceOrderLink(this.getOrderId, this.originalOrder)
    },

   async modifyOrder () {
      if (await !this.formatPrice()) return

      var id = this.companyUID
      if (this.order['.key']) delete this.order['.key']
      if (this.order.sageID === undefined) this.order.sageID = ''
      if (this.order.transmitterPhone === undefined) this.order.transmitterPhone = ''
      if (this.order.receiverPhone === undefined) this.order.receiverPhone = ''
      if (this.order.payerPhone === undefined) this.order.payerPhone = ''
      if (typeof this.order.receiverPlaceId === 'undefined') this.order.receiverPlaceId = ''
      if (typeof this.order.transmitterPlaceId === 'undefined') this.order.transmitterPlaceId = ''
      if (typeof this.order.transmitterLat === 'undefined') this.order.transmitterLat = 0.001
      if (typeof this.order.transmitterLong === 'undefined') this.order.transmitterLong = 0.001
      if (typeof this.order.receiverLat === 'undefined') this.order.receiverLat = 0.001
      if (typeof this.order.receiverLong === 'undefined') this.order.receiverLong = 0.001
      this.order.taxes = this.taxes
      this.order.taxesComment = this.taxesComment
      this.order.price = this.formatPrice()

      if (this.dropzoneFile !== '') this.order.docs = this.dropzoneFile
      this.$refs.delivLocDetails.saveToAddressbook(this.order)

      if (this.$route.query.archive && this.$route.query.archivedOrder) {
        dbArchives2.ref('database/transporter/' + id + '/deliveries/' + this.getOrderId).update(this.order).then(() => {
          // ======================== ADD MODIFY ORDER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'MODIFY_ORDER_ARCHIVE', 'date': Date.now()})
        })
      } else if (!this.$route.query.archive && this.$route.query.archivedOrder) {
        dbArchives2.ref('database/transporter/' + id + '/deliveries/' + this.getOrderId).update(this.order).then(() => {
          // ======================== ADD MODIFY ORDER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'MODIFY_ORDER_ARCHIVE', 'date': Date.now()})
        })
      } else {
        db.ref('database/transporter/' + id + '/deliveries/' + this.getOrderId).update(this.order).then(() => {
          // ======================== ADD MODIFY ORDER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'MODIFY_ORDER', 'date': Date.now()})
        })
        db.ref('bdcQueue/' + id).child(this.getOrderId).set(this.randomPdfString(12))
      }

      this.close()
    },

    // 'async' fixes bug with order.price in Modify somehow
    formatPrice () {
      if (typeof this.order.price === 'undefined' || !this.order.price.toString().length > 0 || this.order.price === '') {
        this.feedbackMessage = this.$t('OrderInfo.modal.modify_modal.price_error')
        return false
      } else {
        this.feedbackMessage = ''
        return Number(this.order.price).toFixed(2)
      }
    },

    setPriceOrderLink (orderId, order) {
      let priceOrderLink = []

      let priceObj = {
        orderId: orderId,
        price: order.price,
        orderInfo: order
      }

      priceOrderLink.push(priceObj)
      return priceOrderLink
    },

    /** Calculates the price the user can input in the price field (Order price - all previous dispatch prices) */
    calculateMaxInputPrice (order) {
      const history = order.historySync
      let orderMaxPrice = Number(order.price)

      for (const historyId in history) {
        if (Object.hasOwnProperty.call(history, historyId)) {
          const historyInfo = history[historyId]
          orderMaxPrice = orderMaxPrice - Number(historyInfo.price || historyInfo.prix || 0)
        }
      }

      return orderMaxPrice.toFixed(2) || 0
    },

    onSendOrderToTransporter () {
      var o = {...this.order}
      var orderID = this.getOrderId
      var id = this.companyUID

      this.$refs.delivLocDetails.saveToAddressbook(this.order)

      this.carriers.forEach((element) => {
        if (element['.key'] === this.sendOrder.carrier) this.sendOrder.carrierName = element['.value']
      })

      o.transferedFrom = id
      o.idFrom = orderID
      delete o.codeSecret
      delete o.invoice
      delete o['.key']
      delete o.refTransfered
      delete o.priceTransfered
      delete o.isTransfered
      delete o.idTransfer
      delete o.historySync
      delete o.history

      o.creationDate = Date.now()
      o.nbDispatch = 0
      o.source = this.userInfo.name
      o.payerName = this.userInfo.name
      o.payerAddress = this.userInfo.address
      o.payerCity = this.userInfo.city
      o.payerPostcode = this.userInfo.postcode
      o.payerProvince = this.userInfo.province
      o.payerEmail = this.userInfo.email
      o.payerPhone = this.userInfo.phone
      o.payerFax = this.userInfo.fax
      o.payerContact = ''
      o.payerCountry = ''
      o.payer = id
      o.sageID = this.userInfo.sageID || ''
      o.cigleOfTransp = o.transpCigle
      o.receiverPhone = o.receiverPhone + ''
      o.receiverFax = o.receiverFax + ''
      o.transmitterPhone = o.transmitterPhone + ''
      o.transmitterFax = o.transmitterFax + ''
      o.transmitterLat = o.transmitterLat || ''
      o.transmitterLong = o.transmitterLong || ''
      o.receiverLat = o.receiverLat || ''
      o.receiverLong = o.receiverLong || ''
      o.transmitterPlaceId = o.transmitterPlaceId || ''
      o.receiverPlaceId = o.receiverPlaceId || ''

      db.ref('database/transporter/' + this.sendOrder.carrier + '/unprocessed/').push().set(o)
      db.ref('database/transporter/' + id + '/deliveries/' + orderID).update({'priceTransfered': o.price, 'status': 'Transférée', 'nameTransfered': this.sendOrder.carrierName, 'isTransfered': this.sendOrder.carrier}).then(() => {
        // ======================== ADD SEND TO CARRIER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'SEND_TO_CARRIER', 'date': Date.now(), 'targetName': this.sendOrder.carrierName})
        // ======================== ADD SEND TO CARRIER LOG =======================
      })
      this.close()
    },

    updateTransitLocation (addressData) {
      this.order.latitude = addressData.latitude
      this.order.longitude = addressData.longitude
      this.isTransitLocationFilled = true
    },

    async saveTransitLocation () {
      if (!await this.checkTransitInfo()) return

      let newStatus = 'Transit'

      db.ref('database/transporter/' + this.companyUID + '/deliveries/' + this.getOrderId).update({'longitude': this.order.longitude, 'latitude': this.order.latitude, 'status': newStatus}).then(() => {
        // Add change status log
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'CHANGE_ORDER_STATUS', 'status': this.order.status, 'date': Date.now()})
      }).catch(function (error) {
        console.log(error)
      })

      this.close() // Close modal
    },

    async checkTransitInfo () {
      if (this.isTransitLocationFilled) {
        let isNoteCreated = await this.$refs.createNoteJS.onSaveNote(this.getOrderId)
        if (isNoteCreated) return true
      }
      this.errorMessage = this.$t('OrderInfo.modal.transit_status.error_message')
    },

    saveCancelReason () {
      if (!this.checkCancelInfo()) return

      let newStatus = 'Cancel'

      db.ref('database/transporter/' + this.companyUID + '/deliveries/' + this.getOrderId).update({'status': newStatus, 'cancelReason': this.cancelReason}).then(() => {
        // Add change status LOG
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'CHANGE_ORDER_STATUS', 'status': newStatus, 'date': Date.now()}).then(
          this.sendToNewRouter('OrderCurrent')
        )
      }).catch(function (error) {
        console.log(error)
      })
    },

    checkCancelInfo () {
      if (this.cancelReason.length >= 10) return true
      else this.errorMessage = this.$t('OrderInfo.modal.cancel_status.error_message')
    },

    /** When status is changed to @finished */
    async saveFinishedBill () {
      if (!await this.checkFinishedInfo()) return
        let newStatus = 'Terminée'

        db.ref('database/transporter/' + this.companyUID + '/deliveries/' + this.getOrderId).update({'status': newStatus, 'billNum': this.billInfo, 'manuallyBilled': true}).then(() => {
          // Add change status LOG
          this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'CHANGE_ORDER_STATUS', 'status': newStatus, 'date': Date.now()}).then(
            this.sendToNewRouter('OrderCurrent')
          )
        }).catch(function (error) {
          console.log(error)
        })
    },

    sendToNewRouter (path) {
      this.$router.push({name: `${path}`})
    },

    /**  was created */
    async checkFinishedInfo () {
      if (this.billInfo.length > 0) {
        let isNoteCreated = await this.$refs.createNoteJS.onSaveNote(this.getOrderId)
        if (isNoteCreated) return true
      }
      this.errorMessage = this.$t('OrderInfo.modal.finished_status.error_message')
    },

    changeStatus (status) {
      const id = this.companyUID
      this.newSelectedStatus = status

      if (status.toUpperCase() === 'TRANSIT') this.isTransitModal = true // Open Transit modal
      else if (status.toUpperCase() === 'CANCEL') this.isCancel = true // Open Cancel modal
      else if (status.toUpperCase() === 'TERMINÉE') this.isFinished = true // Open Finished modal
      else this.noteModal = true

      if (status !== 'Transférée') db.ref('test/transporter/' + id + '/pendingTransfer/' + this.getOrderId).set(null)
    },

    /** From child component @emits CreateNote.vue because we want users to add a note when they change status
    */
    saveStatus () {
      const newSelectedStatus = this.newSelectedStatus
      const id = this.companyUID

      db.ref('database/transporter/' + id + '/deliveries/' + this.getOrderId).child('status').set(newSelectedStatus).then(() => {
        this.noteModal = false
        // Add change status log
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'CHANGE_ORDER_STATUS', 'status': newSelectedStatus, 'date': Date.now()})
      })
    },

    randomPdfString (length) {
      var text = ''
      var possible = 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      return text + '.pdf'
    },

    modifyTransferAction () {
      var id = this.companyUID

      if (this.$route.query.archive && this.$route.query.archivedOrder) {
        dbArchives2.ref('database/transporter/' + id + '/deliveries/' + this.getOrderId).update(this.modifyTransfer).then(() => {
          // ======================== ADD MODIFY TRANSFER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'MODIFY_TRANSFER', 'date': Date.now()})
          // ======================== ADD MODIFY TRANSFER LOG =======================
          this.modifyTransfer.refTransfered = ''
          this.modifyTransfer.priceTransfered = ''
        })
      } else if (!this.$route.query.archive && this.$route.query.archivedOrder) {
        dbArchives2.ref('database/transporter/' + id + '/deliveries/' + this.getOrderId).update(this.modifyTransfer).then(() => {
          // ======================== ADD MODIFY TRANSFER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'MODIFY_TRANSFER', 'date': Date.now()})
          // ======================== ADD MODIFY TRANSFER LOG =======================
          this.modifyTransfer.refTransfered = ''
          this.modifyTransfer.priceTransfered = ''
        })
      } else {
        db.ref('database/transporter/' + id + '/deliveries/' + this.getOrderId).update(this.modifyTransfer).then(() => {
          // ======================== ADD MODIFY TRANSFER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.getOrderId, 'action': 'MODIFY_TRANSFER', 'date': Date.now()})
          // ======================== ADD MODIFY TRANSFER LOG =======================
          this.modifyTransfer.refTransfered = ''
          this.modifyTransfer.priceTransfered = ''
        })
      }
    },

    openNote (notes, isAllowCreateNote) {
      var id = this.companyUID
      db.ref('database/transporter/' + id + '/deliveries/' + this.getOrderId).update({readTrans: true})

      this.isAllowCreateNote = isAllowCreateNote
      this.loadedNotes = notes
      this.chat = true
    },
    onResize: _.debounce(function () {
      this.isScreenSmall = window.innerWidth < 800
    }, 50)
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },

  computed: {
    returnIsOrderArchived () {
      /** Doing this because @param this.$route.query.archivedOrder returns a string 'true' */
      if (this.$route.query.archivedOrder) return true
      else return false
    },
    countPhotos () {
      let order = this.originalOrder
      let count = 0

      if (!this.checkIsUndefined(order.photos)) count += order.photos.length

      if (!this.checkIsUndefined(order.bodyPhotos)) count += order.bodyPhotos.length

      if (!this.checkIsUndefined(order.historySync)) {
        const history = order.historySync
        for (const key in history) {
          if (Object.hasOwnProperty.call(history, key)) {
            if (!this.checkIsUndefined(history.dropPhotos)) count += history.dropPhotos.length
          }
        }
      }

      return count
    },

    isOrderTransfered () {
      if (this.originalOrder.isTransfered && this.originalOrder.idTransfer) return true
      else return false
    },

    isTransferArchived () {
      if (this.checkIsUndefined(this.transfer2)) return false
      else return true
    },

    // Return properly translated status because this is coded very well smile :)
    translatedStatus () {
      let status = this.newSelectedStatus

      switch (status) {
        case 'Attente':
          status = 'waiting'
          break

        case 'Transférée':
          status = 'transfered'
          break

        case 'Terminée':
          status = 'finished'
          break

          case 'Cancel':
          status = 'canceled'
          break

        case 'Reject':
          status = 'rejected'
          break

        default:
          break
      }
      status = status.toLowerCase()
      return this.$t(`Search.status.${status}`)
    },

    listOrdered () {
      let sortedArray = this.liste.concat()
      return this.sortAsc(sortedArray)
    },

    sageIDonly () {
      return this.addressbook.filter(customer => customer.sageID)
    },

    hasProvince () {
      return this.addressbook.filter(customer => customer.province && customer.city && customer.country)
    },

    carriersOrdered () {
      let sortedArray = this.carriers.concat()
      return this.sortAsc(sortedArray)
    },

    noteFilled () {
      return (this.note.text !== '' && this.note.name !== '')
    },

    dispatchFormFilled () {
      var o = this.order
      return (
        this.dispatchOrder.chauffeur !== '' &&
        o.transmitterName !== '' &&
        o.transmitterAddress !== '' &&
        o.transmitterCountry !== '' &&
        o.transmitterCity !== '' &&
        o.transmitterPostcode !== '' &&
        o.transmitterProvince !== '' &&
        o.receiverName !== '' &&
        o.receiverAddress !== '' &&
        o.receiverCountry !== '' &&
        o.receiverCity !== '' &&
        o.receiverPostcode !== '' &&
        o.receiverProvince !== '')
    },

    sendFormFilled () {
      var o = this.order
      return (
        this.sendOrder.carrier !== '' &&
        o.transmitterName !== '' &&
        o.transmitterAddress !== '' &&
        o.transmitterCountry !== '' &&
        o.transmitterCity !== '' &&
        o.transmitterPostcode !== '' &&
        o.transmitterProvince !== '' &&
        o.receiverName !== '' &&
        o.receiverAddress !== '' &&
        o.receiverCountry !== '' &&
        o.receiverCity !== '' &&
        o.receiverPostcode !== '' &&
        o.receiverProvince !== '')
    },

    orderChosen () {
      return (this.inspectionOrder.key !== '')
    },

    emailEntered () {
      return (this.inspectionOrder.email !== '' && this.validateEmail(this.inspectionOrder.email) && this.inspectionOrder.key !== '')
    },

    formCompleted () {
      var o = this.order
      return (
        o.receiverName !== '' &&
        o.receiverAddress !== '' &&
        o.receiverCountry !== '' &&
        o.receiverCity !== '' &&
        o.receiverPostcode !== '' &&
        o.receiverProvince !== '' &&
        o.payerName !== '' &&
        o.payerAddress !== '' &&
        o.payerCountry !== '' &&
        o.payerCity !== '' &&
        o.payerPostcode !== '' &&
        o.payerProvince !== '' &&
        o.transmitterName !== '' &&
        o.transmitterAddress !== '' &&
        o.transmitterCountry !== '' &&
        o.transmitterCity !== '' &&
        o.transmitterPostcode !== '' &&
        o.transmitterProvince !== '' &&
        ((this.isSageOne && o.price !== '') || !this.isSageOne))
    },

    isSageOne () {
      return this.userInfo.isSageOne
    },

    companyUID () {
      return this.$store.state.authorization.company
    },

    uid () {
      return this.$store.state.user.uid
    },

    userInfo () {
      return this.$store.state.userInfo
    },

    getOrderId () {
      return this.$route.query.orderId
    },

    findLastBody () {
      let lastBody = {}
      let index = 0

      for (const key in this.originalOrder.historySync) {
        if (Object.hasOwnProperty.call(this.originalOrder.historySync, key)) {
          const history = this.originalOrder.historySync[key]
          if (history.body) lastBody = {index: index, body: history.body}
        }
        index++
      }

      return lastBody
    }
  },

  watch: {
    notes: function (snapshot) {
      if (snapshot) {
        this.reversedNotes = JSON.parse(JSON.stringify(snapshot))
        this.reversedNotes.reverse()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .doc_info_wrapper {
    display: flex;
    flex-direction: row;
  }

  .doc_info_container:nth-child(1) {
    width: 30%;
  }

  .doc_info_container:nth-child(2) {
    flex-grow: 1;
  }
  .content-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .main-content-container {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .text-info-container {
    width: 25%;
  }

  .special-info-container {
    width: 75%;
  }

  .flex {
    display: flex;
  }

  .f_row {
    flex-direction: row;
  }

  .f_column {
    flex-direction: column
  }

  .photo-container {
    display: flex;
    overflow-x: auto;
    flex-wrap: wrap;
  }
  
  img.mini {
    max-height: 145px;
    max-width: 185px;
    margin: 4px 4px 4px 4px;
    cursor: pointer;
  }

  img.medium {
    min-width: 40%;
    max-width: 80%;
  }

  .other-info {
    background-color: white;
    overflow: hidden;
    flex-grow: 1;
    max-width: 50%
  }

  #location{
    height: 300px;
    overflow: hidden;
  }
  #chat{
    position: relative;
  }

  @media (max-width: 900px){
    .main-content-container {
      display: flex;
      flex-direction: column;
    }
    #info{
      display: block;
    }
    .text-info-container {
      width: 97vw;
    }
    .special-info-container {
      width: 97vw;
    }
  }
  .info {
    border-bottom: 1px solid #d5d5d5;
    overflow-x: auto;
  }

  .fa-exclamation, .fa-dollar{
    margin-left: 0.25rem;
  }

  .placesSearch {
    max-width: 93%;
    border: 1px solid;
    border-radius: 2px;
  }
</style>
